export default "__VITE_ASSET__DW0FAWDP__"